// TransactionCard.tsx
import React from "react";
import { TransactionCardProps } from "../types/revenue.types";
import RevenueService from "../../../services/revenueService";

export const TransactionCard: React.FC<TransactionCardProps> = ({
  transaction,
  colorTheme,
}) => {
  return (
    <div
      style={{
        background: colorTheme.cardBg,
        borderRadius: "12px",
        padding: "16px",
        border: "1px solid #f1f5f9",
        marginBottom: "12px",
      }}
    >
      {/* Transaction Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "12px",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: colorTheme.gray900,
            }}
          >
            {transaction.appointment?.patient?.first_name}{" "}
            {transaction.appointment?.patient?.last_name}
          </div>
          <div
            style={{
              fontSize: "12px",
              color: colorTheme.gray500,
            }}
          >
            {new Date(transaction.transaction_date).toLocaleDateString()}
          </div>
        </div>
        <div
          style={{
            fontSize: "16px",
            fontWeight: "700",
            color: colorTheme.gray900,
          }}
        >
          {RevenueService.formatCurrency(transaction.total_amount)}
        </div>
      </div>

      {/* Service & Provider Info */}
      <div
        style={{
          background: colorTheme.gray50,
          borderRadius: "8px",
          padding: "8px 12px",
          marginBottom: "12px",
          fontSize: "12px",
        }}
      >
        <div style={{ marginBottom: "4px" }}>
          <strong>Service:</strong>{" "}
          {transaction.service?.name || "Unknown Service"}
        </div>
        <div>
          <strong>Worker:</strong> {transaction.service?.provider?.first_name}{" "}
          {transaction.service?.provider?.last_name}
        </div>
      </div>

      {/* Revenue Breakdown */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px",
          fontSize: "12px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ color: colorTheme.gray600 }}>🏥 Clinic:</span>
          <span style={{ fontWeight: "500", color: colorTheme.primary }}>
            {RevenueService.formatCurrency(transaction.clinic_amount)}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ color: colorTheme.gray600 }}>👨‍⚕️ Worker:</span>
          <span style={{ fontWeight: "500", color: colorTheme.success }}>
            {RevenueService.formatCurrency(transaction.provider_amount)}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ color: colorTheme.gray600 }}>👑 Owner:</span>
          <span style={{ fontWeight: "500", color: colorTheme.warning }}>
            {RevenueService.formatCurrency(transaction.owner_amount || 0)}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ color: colorTheme.gray600 }}>❤️ Charity:</span>
          <span style={{ fontWeight: "500", color: colorTheme.charity }}>
            {RevenueService.formatCurrency(transaction.charity_amount || 0)}
          </span>
        </div>
        {(transaction.referrer_amount > 0 || transaction.referrer_name) && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gridColumn: "1 / -1",
            }}
          >
            <span style={{ color: colorTheme.gray600 }}>
              🤝 Referrer ({transaction.referrer_name || "Unknown"}):
            </span>
            <span style={{ fontWeight: "500", color: "#8b5cf6" }}>
              {RevenueService.formatCurrency(transaction.referrer_amount || 0)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
